import { api, unwrap } from "./httpClient";

interface TranslateResponse {
  translated: string;
}

export const translateText = async (params: {
  text: string;
  targetLang: "fr" | "en" | "de" | "pt";
  sourceLang?: "fr" | "en" | "de" | "pt";
}): Promise<string> => {
  const data = await unwrap<TranslateResponse>(
    api({
      method: "POST",
      url: "/i18n/translate",
      data: params,
    })
  );
  return data.translated;
};


